(function (root) {
  'use strict';
  var config = root.MNL_RECIPE_CONFIG || {};
  var names = ['Caféine Anhydre', 'L-Théanine', 'L-Tyrosine', 'L-Citrulline', 'Glycérol', 'Sel Rose Himalaya', 'Beta-Alanine', 'Bétaïne Anhydre', 'Taurine', 'Créatine Monohydrate', 'Électrolytes (K · Mg · Na)', 'Pipérine', 'Caféine', 'Sel rose', 'Béta-Alanine', 'Bêta-Alanine', 'Bétaïne', 'Créatine', 'Électrolytes', "Sel rose de l'Himalaya", 'Sel rose de l’Himalaya', "Sel de l'Himalaya", 'Sel de l’Himalaya', 'Complexe électrolytique'];
  var markers = ['Formule', 'Saveur', 'Format', 'Intensité', 'Intensite', 'Objectif', 'Objectifs', 'Sport', 'Sans stimulants'];
  var flavors = ['Ice Tea', 'Framboise Bleue', 'Neutre', 'Citron Frais', 'Pastèque', 'Cola'];
  var state = { blocked: true, reason: 'checking', pending: false };
  var currentRead = null;
  var cartRevision = 0;
  function isPrework(line) {
    if (!line) return false;
    return String(line.product_id || '').replace(/^gid:\/\/shopify\/Product\//, '') === String(config.productId || '15946188358019') ||
      line.handle === 'pre-workout-mynutrilab-personnalisable-au-mg-pres' ||
      (config.variantIds || []).some(function (id) { return String(id) === String(line.variant_id || line.id); }) ||
      /^MNL-PW-(?:(?:15|20|25|30|35|40|45|50|55|60)-(?:S|SS|P)|DOSES-(?:15|20|25|30|35|40|45|50|55|60))-(?:D|DP|E|EP|H|HP)$/.test(String(line.sku || ''));
  }
  function propertyMap(properties) {
    var map = Object.create(null);
    if (Array.isArray(properties)) properties.forEach(function (p) { if (p && p.name != null) map[p.name] = p.value; });
    else Object.keys(properties || {}).forEach(function (name) { map[name] = properties[name]; });
    return map;
  }
  function validateLine(line) {
    if (!isPrework(line)) return { valid: true, required: false };
    var map = propertyMap(line.properties);
    var count = 0;
    var invalid = false;
    Object.keys(map).forEach(function (name) {
      var value = String(map[name] == null ? '' : map[name]).trim();
      if ((name === 'Caféine' || name === 'Créatine') && !/\d/.test(value)) return;
      if (names.indexOf(name) >= 0) {
        var match = value.match(/^(\d+(?:[.,]\d+)?)\s*(mg|g)$/i);
        if (!match || !Number.isFinite(Number(match[1].replace(',', '.'))) || Number(match[1].replace(',', '.')) <= 0) invalid = true;
        else count++;
      } else if (name.charAt(0) !== '_' && markers.indexOf(name) < 0 && /(?:^|[^0-9.,])\d+(?:[.,]\d+)?\s*(mg|g)\b/i.test(value)) invalid = true;
    });
    var flavor = String(map.Saveur == null ? '' : map.Saveur).trim();
    if (flavors.indexOf(flavor) < 0) invalid = true;
    if (map._recharge) {
      try {
        var raw = String(map._recharge).trim().replace(/-/g, '+').replace(/_/g, '/');
        raw += '='.repeat((4 - raw.length % 4) % 4);
        var decoded = JSON.parse(root.atob(raw));
        if (!decoded || typeof decoded !== 'object' || Array.isArray(decoded) || !decoded.d || typeof decoded.d !== 'object' || Array.isArray(decoded.d)) invalid = true;
      } catch (_) { invalid = true; }
    }
    return { valid: count > 0 && !invalid, required: true, reason: count ? 'incomplete' : 'missing' };
  }
  function validateCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return { valid: false, reason: 'unavailable' };
    var bad = cart.items.filter(function (line) { return !validateLine(line).valid; });
    return { valid: bad.length === 0, reason: bad.length ? 'missing' : '', lines: bad };
  }
  function assertAddItem(line) {
    if (!validateLine(line).valid) {
      var error = new Error(config.messages && config.messages.explanation || 'Confirm the composition in the configurator before adding this pre-workout.');
      error.code = 'recipe_required';
      throw error;
    }
  }
  var api = { isPrework: isPrework, validateLine: validateLine, validateCart: validateCart, assertAddItem: assertAddItem,
    isCheckoutBlocked: function () { return state.blocked || state.pending; }, refresh: refresh };
  root.MNL_RECIPE_GUARD = api;
  if (!root.document) return;
  var doc = root.document;
  function route(name) { return ((root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/').replace(/\/?$/, '/') + name; }
  function setState(result) { state.blocked = !result.valid; state.reason = result.reason; render(); return result; }
  function refresh(fresh) {
    if (currentRead) return fresh ? currentRead.then(function () { return refresh(); }) : currentRead;
    var controller = typeof root.AbortController === 'function' ? new root.AbortController() : null;
    var revision = cartRevision;
    var timer;
    currentRead = new Promise(function (resolve, reject) {
      timer = root.setTimeout(function () { if (controller) controller.abort(); reject(new Error('cart_timeout')); }, 10000);
      Promise.resolve().then(function () { return root.fetch(route('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller && controller.signal }); }).then(function (response) {
        if (!response.ok) throw new Error('cart_unavailable');
        return response.json();
      }).then(resolve).catch(reject);
    }).then(function (cart) {
      return revision === cartRevision ? setState(validateCart(cart)) : { valid: false, reason: 'stale' };
    }).catch(function () { return setState({ valid: false, reason: 'unavailable' }); }).finally(function () {
      root.clearTimeout(timer); currentRead = null;
      if (revision !== cartRevision) refresh();
    });
    return currentRead;
  }
  function warning(host) {
    var box = host.querySelector('[data-mnl-recipe-warning]');
    if (!box) {
      box = doc.createElement('div'); box.className = 'mnl-recipe-warning'; box.setAttribute('data-mnl-recipe-warning', ''); box.setAttribute('role', 'alert');
      var text = doc.createElement('p'); text.setAttribute('data-mnl-recipe-message', ''); box.appendChild(text);
      var configure = doc.createElement('a'); configure.href = config.configureUrl; configure.textContent = config.messages.configure; box.appendChild(configure);
      var cart = doc.createElement('a'); cart.href = route('cart'); cart.textContent = config.messages.review_cart; box.appendChild(cart);
      host.prepend(box);
    }
    box.hidden = !state.blocked || state.reason === 'checking';
    var message = box.querySelector('[data-mnl-recipe-message]');
    if (message) message.textContent = state.reason === 'unavailable' ? config.messages.unavailable : config.messages.cart_requires_recipe;
    return box;
  }
  function render() {
    if (!config.messages || !doc.body) return;
    doc.querySelectorAll('.mnl-cart__wrap, #mnl-hd-cart-body').forEach(warning);
    doc.querySelectorAll('.mnl-cart__express--standalone').forEach(function (box) {
      if (state.blocked || state.pending) { box.inert = true; box.setAttribute('data-mnl-recipe-inert', ''); }
      else if (box.hasAttribute('data-mnl-recipe-inert')) { box.removeAttribute('data-mnl-recipe-inert'); box.inert = box.hasAttribute('data-mnl-cart-busy'); }
    });
    doc.querySelectorAll('.mnl-cart__checkout, .mnl-cart__fixedbar-cta, .mnl-hd-cart__checkout').forEach(function (link) {
      link.setAttribute('data-mnl-recipe-state', state.blocked ? 'blocked' : 'ready');
    });
  }
  function checkoutURL(link) {
    if (link.hasAttribute('data-mnl-recipe-checkout')) return link.getAttribute('data-mnl-recipe-checkout');
    try {
      var url = new URL(link.href, root.location.href);
      if (url.origin !== root.location.origin) return null;
      if (/\/checkout\/?$/.test(url.pathname) || /\/discount\//.test(url.pathname) && /\/checkout\/?$/.test(url.searchParams.get('redirect') || '')) return url.href;
    } catch (_) {}
    return null;
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function pendingCart() { return root.MNL_CART && (root.MNL_CART.hasPending() || root.MNL_CART.isBusy && root.MNL_CART.isBusy()); }
  function targetLocked(target) { return target && (target.hasAttribute('data-mnl-cart-busy') || target.getAttribute('aria-disabled') === 'true' && !target.hasAttribute('data-mnl-recipe-checkout')); }
  function checkout(event, url, target) {
    stop(event);
    if (state.pending || pendingCart() || targetLocked(target)) return;
    state.pending = true; render();
    refresh(true).then(function (result) {
      if (result.valid && !pendingCart() && !targetLocked(target)) root.location.assign(url);
      else if (pendingCart() || targetLocked(target)) return;
      else {
        var host = target && target.closest('#mnl-hd-cart-body') || doc.querySelector('.mnl-cart__wrap');
        if (host) { var box = warning(host); box.tabIndex = -1; box.focus(); }
        else root.location.assign(route('cart'));
      }
    }).finally(function () { state.pending = false; render(); });
  }
  doc.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var link = event.target && event.target.closest && event.target.closest('a[href], [data-mnl-recipe-checkout]');
    if (!link) return;
    var url = checkoutURL(link);
    if (url) checkout(event, url, link);
  }, true);
  doc.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    var form = event.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action*="/cart/add"]')) {
      var data = new root.FormData(form);
      var line = { id: data.get('id'), properties: {} };
      data.forEach(function (value, key) { var match = key.match(/^properties\[(.+)\]$/); if (match) line.properties[match[1]] = value; });
      if (!validateLine(line).valid) { stop(event); root.location.assign(config.configureUrl); }
    } else if (event.submitter && event.submitter.name === 'checkout' || /\/checkout\/?$/.test(form.getAttribute('action') || '')) checkout(event, route('checkout'), event.submitter);
  }, true);
  doc.addEventListener('mnl:cart:updated', function () { cartRevision++; state.blocked = true; state.reason = 'checking'; render(); refresh(); });
  doc.addEventListener('mnl:cart:open', function () { render(); refresh(); });
  doc.addEventListener('mnl:cart:opened', function () { render(); refresh(); });
  function start() {
    render(); refresh();
    if (root.MutationObserver) new root.MutationObserver(function (changes) {
      if (changes.some(function (change) { return Array.prototype.some.call(change.addedNodes, function (node) { return node.nodeType === 1 && (node.matches('#mnl-hd-cart-body, .mnl-hd-cart__checkout, .mnl-cart__express--standalone') || node.querySelector('.mnl-hd-cart__checkout, .mnl-cart__express--standalone')); }); })) render();
    }).observe(doc.body, { childList: true, subtree: true });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
}(window));
